/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface JobEntryDTO
 */
export interface JobEntryDTO  {
    /**
     * 
     * @type {number}
     * @memberof JobEntryDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof JobEntryDTO
     */
    scopus?: string;
    /**
     * 
     * @type {string}
     * @memberof JobEntryDTO
     */
    pmid?: string;
    /**
     * 
     * @type {string}
     * @memberof JobEntryDTO
     */
    isbn?: string;
    /**
     * 
     * @type {string}
     * @memberof JobEntryDTO
     */
    doi?: string;
    /**
     * 
     * @type {string}
     * @memberof JobEntryDTO
     */
    wos?: string;
    /**
     * 
     * @type {string}
     * @memberof JobEntryDTO
     */
    openAlex?: string;
    /**
     * 
     * @type {number}
     * @memberof JobEntryDTO
     */
    mms?: number;
    /**
     * 
     * @type {JobEntryDTOStatusTypeEnum}
     * @memberof JobEntryDTO
     */
    statusType?: JobEntryDTOStatusTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobEntryDTO
     */
    isDuplicate?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobEntryDTO
     */
    message?: string;
    /**
     * 
     * @type {number}
     * @memberof JobEntryDTO
     */
    jobId?: number;
    /**
     * 
     * @type {Date}
     * @memberof JobEntryDTO
     */
    reimportOn?: Date;
}


/**
 * @export
 */
export const JobEntryDTOStatusTypeEnum = {
    Error: 'ERROR',
    SuccessWithError: 'SUCCESS_WITH_ERROR',
    Success: 'SUCCESS',
    Initial: 'INITIAL'
} as const;
export type JobEntryDTOStatusTypeEnum = typeof JobEntryDTOStatusTypeEnum[keyof typeof JobEntryDTOStatusTypeEnum];


/**
 * Check if a given object implements the JobEntryDTO interface.
 */
export function instanceOfJobEntryDTO(value: object): value is JobEntryDTO {
    return true;
}

export function JobEntryDTOFromJSON(json: any): JobEntryDTO {
    return JobEntryDTOFromJSONTyped(json, false);
}

export function JobEntryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobEntryDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'scopus': json['scopus'] == null ? undefined : json['scopus'],
                  'pmid': json['pmid'] == null ? undefined : json['pmid'],
                  'isbn': json['isbn'] == null ? undefined : json['isbn'],
                  'doi': json['doi'] == null ? undefined : json['doi'],
                  'wos': json['wos'] == null ? undefined : json['wos'],
                  'openAlex': json['openAlex'] == null ? undefined : json['openAlex'],
                  'mms': json['mms'] == null ? undefined : json['mms'],
                  'statusType': json['statusType'] == null ? undefined : json['statusType'],
                  'isDuplicate': json['isDuplicate'] == null ? undefined : json['isDuplicate'],
                  'message': json['message'] == null ? undefined : json['message'],
                  'jobId': json['jobId'] == null ? undefined : json['jobId'],
                'reimportOn': json['reimportOn'] == null ? undefined : (new Date(json['reimportOn'])),
    };
}

export function JobEntryDTOToJSON(json: any): JobEntryDTO {
    return JobEntryDTOToJSONTyped(json, false);
}

export function JobEntryDTOToJSONTyped(value?: JobEntryDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'scopus': value['scopus'],
        'pmid': value['pmid'],
        'isbn': value['isbn'],
        'doi': value['doi'],
        'wos': value['wos'],
        'openAlex': value['openAlex'],
        'mms': value['mms'],
        'statusType': value['statusType'],
        'isDuplicate': value['isDuplicate'],
        'message': value['message'],
        'jobId': value['jobId'],
        'reimportOn': value['reimportOn']?.toISOString(),
    };
}


